import { render, staticRenderFns } from "./BaseSnackbar.vue?vue&type=template&id=7b5b973e"
import script from "./BaseSnackbar.vue?vue&type=script&lang=js"
export * from "./BaseSnackbar.vue?vue&type=script&lang=js"
import style0 from "./BaseSnackbar.vue?vue&type=style&index=0&id=7b5b973e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports